import type { PersistStorage } from 'zustand/middleware';

import { getItem, removeItem, setItem } from './common';

export class ZustandIDBStorage implements PersistStorage<unknown> {
  getItem: (name: string) => Promise<any>;

  removeItem: (name: string) => Promise<void>;

  setItem: (name: string, value: unknown) => Promise<void>;

  constructor() {
    this.removeItem = removeItem.bind(this);
    this.setItem = setItem.bind(this);
    this.getItem = getItem.bind(this);
  }
}
